import { render } from "./SearchIndexCard.vue?vue&type=template&id=8fd70950"
import script from "./SearchIndexCard.vue?vue&type=script&lang=js"
export * from "./SearchIndexCard.vue?vue&type=script&lang=js"
script.render = render

export default script